import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import {CurrencyFormatter, UnitFormatter, UpdatedByFormatter} from '../../../utils/formatters.js';
import {postData} from "../../../utils/request";
import {get, set} from "../../../utils/dotutils";
import {ifCompletedInput} from "../../../utils/other";
import debounce from 'lodash-es/debounce';
import List from './Elements/List';
import Editor from './Elements/Editor';
import {PercentFormatter, ProductColumn, UserFormatter} from "../../../utils/formatters";
import Icon from "../../form/Icon";
import {
    PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE,
    PAYMENT_PRICE_TYPE_UNIT_NET_PRICE,
    PAYMENT_PRICE_TYPES,
    Price, PriceView, calculateItemPrice
} from "../../classes/Price";
import BigNumber from "bignumber.js";
import {loadComponentById} from "../../../utils/components";

const percentColors = [
    {pct: 0.0, color: {r: 216, g: 218, b: 255}},
    {pct: 0.5, color: {r: 245, g: 221, b: 187}},
    {pct: 1.0, color: {r: 255, g: 160, b: 160}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}


class OperationListEditor extends React.Component {

    state = {
        hoverColumnValue: null,
        refresh: new Date().getTime()
    }

    constructor(props) {
        super(props);
        this.hoverDebounce = debounce((value) => {
            this.promisedSetState({hoverColumnValue: value});
        }, 300);
    }

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    setFieldValue = (field, value) => {
        if (this.props.setFieldValue) {
            this.props.setFieldValue(field, value);
        }
    }

    calculateItemPrice = (type, field, item, oldItem) => {
        return calculateItemPrice(type, field, item, oldItem);
    };

    onSourceItemUpdate = async (item, oldItem, field, action) => {
        if (field === "pickedqty") {
            item.qty = item.pickedqty = item.pickedqty === undefined || item.pickedqty === null ? 0 : (item.pickedqty || 1);
        }
        if (field === "qty") {
            item.qty = item.pickedqty = item.qty === undefined || item.qty === null ? 0 : (item.qty || 1);
        }
        item.checked = item.checked || false;
        if (field !== "qty" && field !== "pickedqty") {
            if (item.qty === undefined) {
                item.qty = item.pickedqty = item.pickedqty || 1;
            } else {
                item.qty = item.pickedqty = item.qty || 1;
            }
        }
        if (field === "discount") {
            item.discount = parseFloat(item.discount);
        }
        const saleprice = this.calculateItemPrice("saleprice", field, item, oldItem);
        const listprice = this.calculateItemPrice("listprice", field, item, oldItem);
        if (field === "discount") {
            saleprice.setPrice(new BigNumber(listprice.getPrice()).minus(new BigNumber(listprice.getPrice()).dividedBy(100).multipliedBy(item.discount).toNumber()));
        } else {
            item.discount = new BigNumber(100).minus(new BigNumber(saleprice.getPrice()).dividedBy(listprice.getPrice()).multipliedBy(100)).toNumber().toFixed(2);
        }
        if (field) {
            saleprice.boundTo(item, "saleprice");
        }
        switch (field) {
            case "discount": field = "saleprice"; break;
            case "saleprice_gross": field = "saleprice"; break;
            case "saleprice_gross_total": field = "saleprice"; break;
            case "saleprice_net": field = "saleprice"; break;
            case "listprice_gross": field = "listprice"; break;
            case "listprice_net": field = "listprice"; break;
            case "pickedqty": field = "qty"; break;
        }
        if (JSON.stringify(item) !== JSON.stringify(oldItem)) {
            if (parseInt(item.pickedqty || 0) > 0) {
                item = JSON.parse(JSON.stringify(item));
                const operationitems = this.getOperationItems();
                let newItem = JSON.parse(JSON.stringify(await ((operationitems && operationitems.convert instanceof Function && operationitems.convert(item)) || this.convert(item))));
                const res = await this.onTransferItems({direction: 'toTarget', field, action}, [newItem]);
                if (!newItem.id) {
                    newItem.id = res.data[0].id;
                }
                this.picklist && this.picklist.target && this.picklist.target.refreshBackground();
                this.setState({
                    refresh: new Date().getTime()
                });
                return newItem;
            } else {
                item = JSON.parse(JSON.stringify(item));
                const res = await this.onTransferItems({direction: 'toSource', field, action}, [item]);
                if (!item.id) {
                    item.id = res.data[0].id;
                }
                this.picklist && this.picklist.source && this.picklist.source.refreshBackground();
                this.setState({
                    refresh: new Date().getTime()
                });
                return item;
            }
        }
        return item;
    }

    onTargetItemUpdate = async (item, oldItem, field) => {
        const updateItem = JSON.parse(JSON.stringify(item));
        updateItem.OperationList_id = this.props.values[this.props.componentConfig.idfield];
        const listprice = this.calculateItemPrice("listprice", field, item, oldItem);
        const saleprice = this.calculateItemPrice("saleprice", field, item, oldItem);
        if (updateItem.discount > 100) return false;
        if (field === "discount") {
            saleprice.setPrice(listprice.getPrice() - Math.round(listprice.getPrice() / 100 * updateItem.discount));
        }
        saleprice.boundTo(updateItem, "saleprice");
        listprice.boundTo(updateItem, "listprice");
        if ( ! (Math.sign(updateItem.saleprice) === Math.sign(oldItem.saleprice) || oldItem.saleprice == 0)) return false;
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "items",
            parentid: this.props.values[this.props.componentConfig.idfield],
            action: "componentlist.updateItems",
            items: [updateItem]
        };
        await postData(actionparams);
        this.setState({
            refresh: new Date().getTime()
        });
        return true;
    }

    onTransferItems = async (event, items) => {
        const operationitems = this.getOperationItems();
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: (operationitems && (operationitems.listfield || operationitems.name)) || "items",
            parentid: this.props.values[this.props.componentConfig.idfield]
        };

        let action = "addItemsToList";

        const field = event.field || null;

        items = items.map((item) => {
            if (item.id) {
                action = "updateItems";
            }
            item.OperationList_id = this.props.values[this.props.componentConfig.idfield];
            const fields = {"qty": "qty", "listprice": "listprice", "saleprice": "saleprice", "component_type": "component_type", "component_id": "component_id", "vat": "vat.id", "checked": "checked"};
            if (item.id && field) {
                let _item = {id: item.id, [field]: ((a,b) => a === false ? a : b)(fields[field] ? get(item, fields[field], undefined) : undefined, item[field])};
                if (field === "vat") {
                    _item.saleprice = item.saleprice;
                }
                item = _item;
            } else {
                item = {...Object.keys(fields).reduce((a,b)=> (set(a,b, get(item, fields[b], undefined)),a),{}), id: item.id};
            }
            return item;
        });
        action = event.action || action;

        switch (event.direction) {
            case 'toTarget':
                if (action === "addItemsToList") {
                    items = items.map((item) => ({data: item}));
                }
                actionparams = {
                    ...actionparams,
                    action: "componentlist." + action,
                    items: items
                };
                this.setState({
                    refresh: new Date().getTime()
                });
                return await postData(actionparams);
            case 'toSource':
                actionparams = {
                    ...actionparams,
                    action: "componentlist.removeItemsFromList",
                    items: items
                };
                const ret = await postData(actionparams);
                this.picklist && this.picklist.target && this.picklist.target.refresh();
                this.setState({
                    refresh: new Date().getTime()
                });
                return ret;
        }
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve();
            });
        });
    }

    convert = async (row) => {
        //row.product_id = row.id;
        row.qty = row.pickedqty || 1;
        row.checked = row.checked || false;
        //row.saleprice = row.saleprice || row.listprice;
        const discount = (this.props.values.xtradata || {}).discount;
        if (discount) {
            row.discount = discount;
            row.saleprice = row.listprice - Math.round(row.listprice / 100 * row.discount);
        }
        const vatId = (this.props.values.xtradata || {}).vat || null;
        if (vatId) {
            const vat = await loadComponentById("vatrate", vatId);
            const saleprice = this.calculateItemPrice("saleprice", "vat", {...row, vat: vat}, {...row});
            saleprice.boundTo(row, "saleprice");
            row.saleprice = saleprice.getPrice();
            row.vat = vat;
        }
        return row;
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        //await this.props.saveForm(event, true);
        await this.promisedSetState({discount: ''});
        if (this.componentList) {
            this.componentList.refresh();
        }
    }

    saveForm = async (event) => {
        await this.props.setFieldValue("saved", 1);
        //await this.props.saveForm(event);
        await this.promisedSetState({discount: ''});
        if (this.componentList) {
            this.componentList.refresh();
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        await this.promisedSetState({discount: ''});
    }

    getOperationItems = () => {
        const sortable = true;
        const filterable = true;
        return (this.props.formatOperationItems || ((operationItems) => operationItems))(this.props.operationitems || {
            rowClassName: (rowData) => {
                return {"warning color": !parseInt(rowData.instock)};
            },
            exports: [{as: "excel", label: "Excel", icon: "far fa-file-excel"}],
            //rows: this.props.values.items,
            orderBy: {field: "displayname", direction: "ASC"},
            componentConfig: this.props.componentConfig,
            data: this.props.values,
            listfield: "items",
            aggregations: {
                fields: {
                    "saleprice_net_total": {
                        field: "saleprice_net_total", type: "SUM"
                    },
                    "saleprice_gross_total": {
                        field: "saleprice_gross_total", type: "SUM"
                    },
                    "qty": {
                        field: "qty", type: "SUM"
                    },
                }
            },
            view: ["id","product_id","OperationList_id", "qty", "vat", "instock", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                //"itemid": {header: 'Tételkód', width: 1, sortable, filterable},
                //"id": {header: 'Árukód', width: 1, sortable, filterable},
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 3,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice_gross": {
                    header: "Lista ár",
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="listprice_gross" label={false} focus="focus"
                                           value={props.rowData.listprice_gross}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                />
                },
                "discount": {
                    header: "Kedvezmény",
                    width: 1,
                    sortable,
                    filterable,
                    className: "discount",
                    onHover: (e, field, value, purchaseitem) => {
                        this.hoverDebounce && this.hoverDebounce(purchaseitem.discount);
                    },
                    onLeave: (e, field, value, purchaseitem) => {
                        this.hoverDebounce && this.hoverDebounce(null);
                    },
                    columnCss: (field, value, purchaseitem, purchaseitems) => {
                        const current = parseFloat(purchaseitem.discount || 0).toFixed(2);
                        const percents = purchaseitems.map((purchaseitem) => parseFloat(purchaseitem.discount || 0).toFixed(2)).filter(function (item, pos, self) {
                            return self.indexOf(item) == pos;
                        }).sort();
                        const posPercent = parseFloat((percents.length - percents.indexOf(current)) / percents.length).toFixed(2);
                        //console.log((percents.length - percents.indexOf(current)) / percents.length);
                        return {
                            backgroundColor: getColorForPercentage(posPercent/*percents.indexOf(current) / percents.length*/),
                            fontWeight: this.state.hoverColumnValue == current ? "bold" : "normal"
                        }
                    },
                    renderer: PercentFormatter,
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="discount" label={false} focus="focus"
                                           value={props.rowData.discount}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                />
                },
                "saleprice_gross": {
                    header: "Eladási ár",
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="saleprice_gross" label={false} focus="focus"
                                           value={props.rowData.saleprice_gross}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                /*"saleprice": {
                    header: "Eladási ár",
                    width: 1,
                    sortable,
                    filterable,
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="saleprice" label={false} value={props.rowData.saleprice} saveChanges={ (field, value) => parent.onEditorValueChange(props,value) } />,
                    renderer: CurrencyFormatter
                },*/
                "qty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    className: "unit",
                    tooltip: (value, rowData) => {
                        return parseInt(rowData.instock) < parseInt(rowData.qty) ? "Készlethiány!" : ""
                    },
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="qty" label={false} focus="focus"
                                           value={props.rowData.qty}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                // nettó összesen
                // bruttó összesen
                "saleprice_net_total": {
                    header: "Nettó összesen",
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                },
                "saleprice_gross_total": {
                    header: "Bruttó összesen",
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                },
                ...(this.props.actions === true ? {
                    "actions": {
                        header: " ",
                        width: 1,
                        renderer:
                            (value, rowData) => {
                                return <div>
                                <span className={"btn btn-danger btn-xs"} onClick={(e) => {
                                    e && e.preventDefault();
                                    this.onTransferItems({direction: 'toSource'}, [rowData]);
                                }}><Icon lib="fa" name="trash"/></span>
                                </div>;
                            }
                    }
                } : (this.props.actions !== undefined ? this.props.actions : {}))
            },
            convert: this.convert
        });
    }

    render() {
        const sortable = true;
        const filterable = true;
        const actionButtons = (this.props.actionButtons instanceof Function && this.props.actionButtons()) || this.props.actionButtons || [];
        const hidden = Array.isArray(this.props.hidden) ? this.props.hidden : [this.props.hidden];
        const pool = (this.props.formatPool || ((pool) => pool))(this.props.pool || {
            orderBy: {field: "displayname", direction: "ASC"},
            selection: [],
            component: "product",
            view: "list",
            columns: {
                //"id": {header: 'Árukód', width: 1, sortable, filterable},
                "displayname": {
                    ...ProductColumn("product_id"),
                    width: 3,
                },
                "listprice": {header: 'Lista ár', width: 1, sortable, filterable, renderer: CurrencyFormatter}
            }
        });
        const operationitems = this.getOperationItems();
        const columns = this.props.columns || {
            "label": {
                header: 'Cimke',
                width: 3,
                sortable,
                filterable
            },
            "partner": {
                header: "Partner",
                width: 2,
                sortable,
                filterable,
                renderer: UserFormatter
            },
            "created_by": {
                header: "Létrehozta",
                width: 2,
                renderer: UpdatedByFormatter
            },
            "created_at": {
                header: "Létrehozás időpontja",
                width: 2
            }
        };
        const filter = this.props.filter || [];
        const labels = this.props.labels || {};

        const propsTop = {
            ...this.props,
            actionButtons,
            pool,
            operationitems,
            refresh: this.state.refresh,
            filter,
            labels,
            columns,
            hidden,
            values: this.props.values,
            getProps: this.getProps,
            getValue: this.getValue,
            setFieldValue: this.setFieldValue,
            setState: (state, cb) => {
                this.setState(state, cb);
            },
            loadForm: this.loadForm,
            deleteForm: this.props.deleteForm,
            saveForm: this.saveForm,
            pristineForm: this.pristineForm
        };
        const componentProps = {props: propsTop, state: this.state, parent: this};

        return (this.props.renderer && this.props.renderer(componentProps)) || (
            <Fragment>
                <List boxid={this.props.componentEditor + "ListBox"} {...componentProps} />
                <Editor {...componentProps} />
            </Fragment>
        );
    }
}

export default OperationListEditor;
